export const blurActiveElement = () => document.activeElement?.blur?.()
